/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import {
  ContentBody,
  FavoriteDecorationPosition,
  FavoriteDecoration,
  FavoriteContainer,
  FavoriteContent,
  FavoriteIcon,
  FavoriteText,
} from './styled';

export default function FavoritesEmpty() {
  return (
    <>
      <ContentBody>
        <FavoriteContainer>
          <FavoriteDecorationPosition>
            <FavoriteDecoration />
          </FavoriteDecorationPosition>
          <FavoriteContent>
            <FavoriteIcon />
          </FavoriteContent>
          <FavoriteText>
            Os vídeos marcados como Favoritos no aplicativo HoxxTV aparecem neste menu.
          </FavoriteText>
        </FavoriteContainer>
      </ContentBody>
    </>
  );
}
